import { FaEdit, FaEye, FaTrash } from "react-icons/fa";
import React, { useState, useEffect } from "react";
import "../assets/css/CustomerReport.css";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchCustomers,
  deleteCustomer,
} from "../redux/slices/Customer/customerReportSlice";
import CustomerEditModal from "../modals/CustomerEditModal";
import { Link } from "react-router-dom";
import { fetchUserProfile } from "../redux/slices/branch/userProfileSlice";
import { toast } from "react-toastify";

const CustomerReport = () => {
  const dispatch = useDispatch();

  const { profile } = useSelector((state) => state.userProfile);
  const {
    customers = [],
    loading,
    pagination,
  } = useSelector((state) => state.customerReport || {});

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [deleteDialog, setDeleteDialog] = useState({
    open: false,
    customerId: null,
  });

  const [filters, setFilters] = useState({
    customerId: "",
  });

  const [filterdata,setFilterData]=useState("");

  // 🔹 store photos as { userId: imageUrl }
  const [customerPhotos, setCustomerPhotos] = useState({});
  const [rowsPerPage,setRowsPerPage]=useState(10);
  const [previewImage,setPreviewImage]= useState(null);

  /* ===============================
     FETCH PROFILE
  =============================== */
  useEffect(() => {
    dispatch(fetchUserProfile());
  }, [dispatch]);

  /* ===============================
     FETCH CUSTOMERS (MAIN SOURCE)
  =============================== */
  useEffect(() => {
    if (!profile?.superAdminId) return;

    dispatch(
      fetchCustomers({
        page: pagination.currentPage,
        limit: pagination.limit,
        superAdminId: profile.superAdminId,
        userId: filters.customerId || undefined,
        
      })
    );
  }, [
    dispatch,
    pagination.currentPage,
    pagination.limit,
    rowsPerPage,
    profile?.superAdminId,
    filters.customerId,
  ]);

  

  /* ===============================
     FETCH CUSTOMER PHOTO (PER USER)
  =============================== */
  // const fetchCustomerPhoto = async (userId) => {
  //   try {
  //     if (!userId || customerPhotos[userId]) return;

  //     const res = await fetch(
  //       `https://payyug.in/api/list-kyc?userId=${userId}&superAdminId=${profile?.superAdminId}`
  //     );

  //     if (!res.ok) return;

  //     const data = await res.json();

  //     const photoDoc = data?.documents?.find(
  //       (doc) => doc?.docName?.toLowerCase() === "photo"
  //     );

  //     if (photoDoc?.docImage) {
  //       setCustomerPhotos((prev) => ({
  //         ...prev,
  //         [userId]: `https://payyug.in/uploads/${photoDoc.docImage}`,
  //       }));
  //     }
  //   } catch (err) {
  //     console.error("Photo fetch error:", err);
  //   }
  // };

  const fetchCustomerPhoto = async (userId) => {
    try {
      if (!userId) return null;

      const res = await fetch(
        `https://payyug.in/api/list-kyc?userId=${userId}&superAdminId=${profile?.superAdminId}&createdId=${profile.id}`
      );

      if (!res.ok) return null;

      const data = await res.json();

      const photoDoc = data?.documents?.find(
        (doc) => doc?.docName?.toLowerCase() === "photo"
      );

      if (photoDoc?.docImage) {
        return `https://payyug.in/uploads/${photoDoc.docImage}`;
      }

      return null;
    } catch (err) {
      console.error("Photo fetch error:", err);
      return null;
    }
  };

  /* ===============================
     FETCH PHOTOS WHEN CUSTOMERS LOAD
  =============================== */
  // useEffect(() => {
  //   if (!profile?.superAdminId || !customers.length) return;

  //   customers.forEach((c) => {
  //     if (c.userId && !customerPhotos[c.userId]) {
  //       fetchCustomerPhoto(c.userId);
  //     }
  //   });
  // }, [customers, profile?.superAdminId]);

 const handlepreviewclick = async (row) => {
  try {
    const imageUrl = await fetchCustomerPhoto(row.userId);

    if (imageUrl) {
      setPreviewImage(imageUrl);
    } else {
      toast.error("Image not found.");
    }
  } catch (error) {
    console.log(error);
    toast.error("Error loading image.");
  }
};


  /* ===============================
     FILTER HANDLER
  =============================== */
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  /* ===============================
     PAGINATION HANDLERS
  =============================== */
  const handlePageChange = (newPage) => {
    if (newPage < 1 || newPage > pagination.totalPages) return;

    dispatch(
      fetchCustomers({
        page: newPage,
        limit: pagination.limit,
        superAdminId: profile.superAdminId,
        userId: filters.customerId || undefined,
      })
    );
  };
  // console.log("rowsper page",rowsPerPage);

  const handleRowsPerPageChange = (e) => {
    const value = e.target.value;
    const newLimit = Number(value);
    dispatch(
      fetchCustomers({
        page: 1,
        limit: newLimit,
        superAdminId: profile.superAdminId,
        userId: filters.customerId || undefined,
      })
    );
  };

  /* ===============================
     DELETE HANDLERS
  =============================== */
  const openDeleteDialog = (customerId) =>
    setDeleteDialog({ open: true, customerId });

  const closeDeleteDialog = () =>
    setDeleteDialog({ open: false, customerId: null });

  const confirmDeleteCustomer = async () => {
    if (!deleteDialog.customerId) return;

    await dispatch(deleteCustomer(deleteDialog.customerId));

    dispatch(
      fetchCustomers({
        page: pagination.currentPage,
        limit: pagination.limit,
        superAdminId: profile.superAdminId,
        userId: filters.customerId || undefined,
      })
    );

    closeDeleteDialog();
  };
  // console.log(pagination.limit);

  const filteredCustomers = customers.filter((customer) => {
    if (!filterdata) return true;

    const search = filterdata.toLowerCase();

    return (
      customer.fullName?.toLowerCase().includes(search) ||
      customer.mobileNumber?.includes(search) ||
      customer.aadhaarNumber?.includes(search) ||
      customer.panNumber?.toLowerCase().includes(search)
    );
  });

  /* ===============================
     RENDER
  =============================== */
  return (
    <div className="BranchCustomerReport-container">
      {/* <h2 className="BranchCustomerReport-heading">Customer Report</h2> */}

      {/* 🔹 Filter */}
      <section className="BranchCustomerReport-filter">
        <h2 className="BranchCustomerReport-filter-title">Customer Report Filter</h2>
        <p className="BranchCustomerReport-filter-subtitle">
          Use filters to view specific customer reports
        </p>
        <div className="BranchCustomerReport-filter-form">
          <div className="BranchCustomerReport-filter-form-group">
            <label>Customer Id</label>
            <input
              type="text"
              name="customerId"
              placeholder="Enter customer id"
              value={filters.customerId}
              onChange={handleInputChange}
            />
          </div>
         <div className="BranchCustomerReport-filter-form-group">
            <label>Aadhar/Pan/Name/Mobile No.</label>
            <input
              type="text"
              name="filterdata"
              placeholder="Enter Aadhar/Pan/Name/Mobile Number"
              value={filterdata}
              onChange={(e) => setFilterData(e.target.value)}
            />
          </div>
          
        </div>
      </section>

      {/* 🔹 Rows per page */}
      <div className="BranchCustomerReport-paginationControls">
        <label>
          Rows per page:
          <select 
            // value={pagination.limit}
            value={rowsPerPage} 
            onChange={(e)=>{
            handleRowsPerPageChange(e);
            setRowsPerPage(e.target.value);
          }}>
             {/* <option value={1}>1</option>
              <option value={2}>2</option>
               <option value={3}>3</option>
                <option value={4}>4</option> */}
            <option value={10}>10</option>
            <option value={25}>25</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
            <option value={10000}>ALL</option>
          </select>
        </label>
      </div>

      {/* 🔹 Table */}
      <div className="BranchCustomerReport-tableWrapper">
        <table className="BranchCustomerReport-table">
          <thead>
            <tr>
              <th>SN</th>
              <th>Photo</th>
              <th>Customer ID</th>
              <th>User Name</th>
              <th>Email</th>
              <th>Phone</th>
              <th>Aadhar</th>
              <th>PAN</th>
              <th>Address</th>
              <th>DOB</th>
              <th>Date Of Joining</th>
              <th>Form</th>
              {/* <th>Actions</th> */}
            </tr>
          </thead>

          <tbody>
            {loading ? (
              <tr>
                <td colSpan="12" align="center">
                  Loading...
                </td>
              </tr>
            ) : filteredCustomers.length ? (
              filteredCustomers.map((row, index) => (
                <tr key={row.id}>
                  <td>
                    {(pagination.currentPage - 1) * pagination.limit +
                      index +
                      1}
                  </td>

                  <td>
                    {/* <img
                      src={
                        customerPhotos[row.userId] ||
                        "/default-avatar.png"
                      }
                      alt="Profile"
                      width="40"
                      height="40"
                      style={{ borderRadius: "50%" }}
                    /> */}
                    <button
                      className="preview-button-customer-report"
                      onClick={()=> handlepreviewclick(row)}
                     ><FaEye/></button>
                  </td>

                  <td>{row.userId || "N/A"}</td>
                  <td>{row.fullName || "N/A"}</td>
                  <td>{row.email || "N/A"}</td>
                  <td>{row.mobileNumber || "N/A"}</td>
                  <td>{row.aadhaarNumber || "N/A"}</td>
                  <td>{row.panNumber || "N/A"}</td>
                  <td>{row.address || "N/A"}</td>
                  <td>{new Date(row.dateOfBirth).toLocaleDateString("en-GB").replaceAll("/","-") || "N/A"}</td>
                  <td>{new Date(row.dateOfJoining).toLocaleDateString("en-GB").replaceAll("/","-") || "N/A"}</td>

                  <td>
                    {/* <Link
                      to="/Banking/Report/CustomerCertificates"
                      state={{ row }}
                      className="BranchCustomerCirtificate-open"
                    >
                      Open
                    </Link> */}
                    <Link
                      to="/Banking/Report/CustomerCertificates"
                      state={{
                        row,
                        customerPhoto: customerPhotos[row.userId] || "/default-avatar.png",
                      }}
                      className="BranchCustomerCirtificate-open"
                    >
                      Open
                    </Link>

                  </td>

                  {/* <td>
                    <button
                      className="BranchCustomerReport-edit"
                      onClick={() => {
                        setIsModalOpen(true);
                        setSelectedCustomer(row);
                      }}
                    >
                      <FaEdit />
                    </button>

                    <button
                      className="BranchCustomerReport-delete"
                      onClick={() => openDeleteDialog(row.id)}
                    >
                      <FaTrash />
                    </button>
                  </td> */}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="12" align="center">
                  No records found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* 🔹 Pagination */}
      <div className="BranchCustomerReport-paginationButtons">
        <button
          disabled={pagination.currentPage <= 1}
          onClick={() => handlePageChange(pagination.currentPage - 1)}
        >
          Previous
        </button>

        <span>
          Page {pagination.currentPage} of {pagination.totalPages}
        </span>

        <button
          disabled={pagination.currentPage >= pagination.totalPages}
          onClick={() => handlePageChange(pagination.currentPage + 1)}
        >
          Next
        </button>
      </div>

      <CustomerEditModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        customer={selectedCustomer}
      />

      {/* 🔹 Delete Dialog */}
      {deleteDialog.open && (
        <div className="BranchCustomerReport-deleteOverlay">
          <div className="BranchCustomerReport-deleteDialog">
            <h3>Confirm Delete</h3>
            <p>Are you sure you want to delete this customer?</p>

            <div className="BranchCustomerReport-dialogButtons">
              <button
                onClick={confirmDeleteCustomer}
                className="BranchCustomerReport-confirmBtn"
              >
                Yes, Delete
              </button>
              <button
                onClick={closeDeleteDialog}
                className="BranchCustomerReport-cancelBtn"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {previewImage && (
              <div className="modal-overlay-customer-report" onClick={() => setPreviewImage(null)}>
                <div className="modal-content-customer-report" onClick={(e) => e.stopPropagation()}>
                  <img src={previewImage} alt="KYC Preview" className="modal-image" />
                  <button
                    className="modal-content-customer-report-close-btn"
                    onClick={() => setPreviewImage(null)}
                  >
                    ×
                  </button>
                </div>
              </div>
            )}
    </div>
  );
};

export default CustomerReport;
